/**
 * ============================================================================
 * แหล่งรวม Base URL ของ API / ระบบภายนอก ทั้งโปรเจกต์
 * ============================================================================
 * แก้ที่ไฟล์นี้ไฟล์เดียวเมื่อเปลี่ยนเซิร์ฟเวอร์
 * หรือตั้งค่าผ่าน REACT_APP_* ใน .env.development / .env.production / Docker build args
 *
 * ใช้ผ่าน:
 *   import { admission, mua, site, arit, tabian, muaStatic } from "../config/api";
 * หรือ import เดิมจาก Pages/ADMISSION, Pages/MUA (ยังใช้ได้ — re-export จากที่นี่)
 *
 * Dev: path สัมพัทธ์ + setupProxy.js (เลี่ยง CORS / ชี้ PHP ใน Docker)
 * Prod: โดเมนเต็มจาก .env.production
 * ============================================================================
 */

const isDev = process.env.NODE_ENV === "development";

function trimSlash(url) {
  return String(url || "").replace(/\/$/, "");
}

/** โดเมนเว็บรับสมัคร (หน้า SPA / redirect) */
export const site = trimSlash(
  process.env.REACT_APP_SITE_URL || "https://admission.kpru.ac.th"
);

/**
 * ระบบ admission2017 (PHP)
 * Prod: https://admission.kpru.ac.th/admission2017
 */
export const admission = trimSlash(
  process.env.REACT_APP_ADMISSION_API ||
    (isDev ? "/admission2017" : "https://admission.kpru.ac.th/admission2017")
);

/**
 * FrontEnd_Admission API
 * Prod: https://mua.kpru.ac.th/FrontEnd_Admission
 * (ต้องมี CORS บน mua — ดู FrontEnd_Admission/config/cors.php)
 */
export const mua = trimSlash(
  process.env.REACT_APP_MUA_API ||
    (isDev ? "/FrontEnd_Admission" : "https://mua.kpru.ac.th/FrontEnd_Admission")
);

/** alias ของ mua — ใช้เมื่อโค้ดเก่าอ้าง host โดยตรง */
export const muaHost = mua;

/** FrontEnd_Tabian (ที่อยู่ / โรงเรียน ฯลฯ) */
export const tabian = trimSlash(
  process.env.REACT_APP_TABIAN_API ||
    (isDev ? "/FrontEnd_Tabian" : "https://mua.kpru.ac.th/FrontEnd_Tabian")
);

/** ไฟล์สแตติกบน mua (PDF ประกาศ, imagesbg) */
export const muaStatic = trimSlash(
  process.env.REACT_APP_MUA_STATIC || "https://mua.kpru.ac.th"
);

/** ARIT — PDPA / ThaID / account */
export const arit = trimSlash(
  process.env.REACT_APP_ARIT_URL || "https://arit.kpru.ac.th"
);

/** e-Payment มหาวิทยาลัย */
export const epayment =
  process.env.REACT_APP_EPAYMENT_URL ||
  "https://e-payment.kpru.ac.th/pay/typepayment";

/** basename ของ SPA เช่น /admission */
export const appBasename = (
  process.env.REACT_APP_BASENAME || "/admission"
).replace(/\/$/, "");

/** URL สาธารณะของ SPA บนโดเมน admission */
export const appPublicUrl = `${site}${appBasename}`;

// ---------------------------------------------------------------------------
// Helpers — รวม path ให้สั้นลง
// ---------------------------------------------------------------------------

export function admissionUrl(path = "") {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${admission}${p === "/" ? "" : p}`;
}

export function muaUrl(path = "") {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${mua}${p === "/" ? "" : p}`;
}

/** ดึง array จาก response ของ FrontEnd_Admission ที่ห่อหลายชั้น */
export function unwrapApiList(payload) {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== "object") return [];
  if (Array.isArray(payload.data)) return payload.data;
  if (payload.data && Array.isArray(payload.data.data)) return payload.data.data;
  return [];
}

export function siteUrl(path = "") {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${site}${p === "/" ? "" : p}`;
}

export function aritUrl(path = "") {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${arit}${p === "/" ? "" : p}`;
}

/** PDPA GET — ตรวจว่าเคยยอมรับ PDPA หรือยัง */
export function pdpaGetUrl(citizent) {
  return (
    `${arit}/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=` +
    encodeURIComponent(citizent) +
    "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
  );
}

/** PDPA หน้ายอมรับ + redirect กลับ */
export function pdpaAgreeUrl(citizent, redirectUrl) {
  return (
    `${arit}/ap/account/?nu=pdpaAgree&code=` +
    btoa(citizent) +
    "&status=" +
    btoa("3") +
    "&url=" +
    btoa(redirectUrl)
  );
}

const api = {
  site,
  admission,
  mua,
  muaHost,
  tabian,
  muaStatic,
  arit,
  epayment,
  appBasename,
  appPublicUrl,
  admissionUrl,
  muaUrl,
  unwrapApiList,
  siteUrl,
  aritUrl,
  pdpaGetUrl,
  pdpaAgreeUrl,
};

export default api;
